import React, {Fragment} from 'react';
import Header from "../../../components/header/HeaderOne";
import SideHeader from "../../../components/SideHeader";
import FooterThree from "../../../components/footer/FooterThree";
import TemplatePortfolioDetails from "../../../templates/portfolio/details";
import { useLocation, useParams } from 'react-router-dom';

const PortfolioDetailsPage = () => {
    const location = useLocation();
    const { id } = useParams();
    const data = location.state ? location.state.portfolioData : null;

    return (
        <Fragment>
            <Header classes={'position-static'}/>
            <SideHeader mobile={true}/>
            <TemplatePortfolioDetails data={data} id={id}/>
            <FooterThree position='fixed'/>
        </Fragment>
    );
};

export default PortfolioDetailsPage;